import React from 'react';
import img_left from '/assets/Image_136.png';
import img_right from '/assets/Image_138.png';


const Creeds = () => {
    return (
        <div className='creeds mt-5'>

            <div className="row">
                <div className="col-lg-1 creedCard img_left">

                </div>
                <div className="col-lg-5 creedCard">
                    <h3>STUDENT CREED</h3>
                    <p className="pb-5 pb-lg-0">I intend to develop myself in a positive manner and avoid anything that will reduce my mental growth or physical health. I intend to develop self-discipline in order to bring out the best in myself and others. I intend to use what I learn in class constructively and defensively to help myself and my fellow man and never to be abusive or offensive.</p>

                    <h3 mt>THE KARATE CREED</h3>
                    <p>I come to you with only KARATE, my empty hands, I have no weapons. But should I be forced to defend myself, my honor or my principles, should it be at matter of life or death, of right or wrong, then here are my weapons, KARATE, my empty hands.</p>
                </div>
                <div className="col-lg-5 creedCard">
                    <h3>ISSHINRYU CODE</h3>
                    <p>A person's heart is the same as heaven and earth.</p>
                    <p>The blood circulating is similar to the moon and sun.</p>
                    <p>A manner of drinking and spitting is either hard or soft.</p>
                    <p>A person's unbalance is the same as a weight.</p>
                    <p>The body should be able to change direction at any time.</p>
                    <p>The time to strike is when the opportunity presents itself.</p>
                    <p>The eye must see all sides.</p>
                    <p>The ear must listen in all directions.</p>
                </div>
                <div className="col-lg-1 creedCard img_right">

                </div>

            </div>


        </div>
    )
}

export default Creeds;